"use client";

import { SafeHydrate } from "@/SafeHydrate";
import React from "react";
import { Phone, MessageCircle, Calendar, ShieldCheck, CircleCheck as CheckCircle2 } from 'lucide-react';
import { motion, useReducedMotion } from "framer-motion";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
export default function BrandCTA() {
  const shouldReduceMotion = useReducedMotion();
  return <section id="fullwidthbrandcta" data-nav="dark" className="bg-primary text-primary-foreground py-16 md:py-20 px-4 sm:px-6 lg:px-8 relative overflow-hidden">
      <div className="max-w-3xl mx-auto text-center relative z-10">
        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 12
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.4
      }} viewport={{
        once: true
      }} className="inline-flex items-center gap-2 px-3.5 py-1.5 rounded-full bg-primary-foreground/10 border border-primary-foreground/20 text-xs font-medium tracking-wide mb-6">
          <ShieldCheck className="w-4 h-4 text-primary-foreground shrink-0" />
          <span>{"RGI & SEAI Registered Plumbers in Dublin"}</span>
        </motion.div>

        <motion.h2 initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.1
      }} viewport={{
        once: true
      }} className="text-3xl sm:text-4xl md:text-5xl font-bold tracking-tight text-primary-foreground leading-tight mb-4">
          Need a Plumber or Heating Engineer in Dublin?
        </motion.h2>

        <motion.p initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.2
      }} viewport={{
        once: true
      }} className="text-lg sm:text-xl text-primary-foreground/90 max-w-2xl mx-auto mb-8 font-normal leading-relaxed">
          Call D4 Plumbing &amp; Heating to discuss a boiler fault, arrange servicing, request a heat pump assessment or book general plumbing work.
        </motion.p>

        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0,
        y: 16
      }} whileInView={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5,
        delay: 0.3
      }} viewport={{
        once: true
      }} className="flex flex-col sm:flex-row items-center justify-center gap-3 sm:gap-4">
          <Button onClick={() => window.location.href = "tel:+353857063869"} size="lg" className="w-full sm:w-auto h-12 px-6 rounded-lg bg-background text-foreground hover:bg-background/90 shadow-md transition-all duration-300 font-semibold group">
            <Phone className="w-5 h-5 mr-2 text-primary group-hover:scale-110 transition-transform duration-300" />
            <span>Call 085 706 3869</span>
          </Button>

          <Button onClick={() => window.location.href = "https://wa.me/353857063869"} size="lg" className="w-full sm:w-auto h-12 px-6 rounded-lg bg-accent text-accent-foreground hover:bg-accent/90 shadow-md transition-all duration-300 font-semibold group">
            <MessageCircle className="w-5 h-5 mr-2 text-accent-foreground group-hover:scale-110 transition-transform duration-300" />
            <span>WhatsApp Us</span>
          </Button>

          <Button asChild variant="outline" size="lg" className="w-full sm:w-auto h-12 px-6 rounded-lg border-2 border-primary-foreground/40 bg-transparent text-primary-foreground hover:bg-primary-foreground/15 hover:border-primary-foreground hover:text-primary-foreground shadow-md transition-all duration-300 font-semibold">
            <Link to="/RequestAJobPage">
              <SafeHydrate><Calendar className="w-5 h-5 mr-2" /></SafeHydrate>
              <span>Request a Quote</span>
            </Link>
          </Button>
        </motion.div>

        <motion.div initial={shouldReduceMotion ? {
        opacity: 1
      } : {
        opacity: 0
      }} whileInView={{
        opacity: 1
      }} transition={{
        duration: 0.5,
        delay: 0.4
      }} viewport={{
        once: true
      }} className="mt-8 pt-6 border-t border-primary-foreground/15 flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-xs sm:text-sm text-primary-foreground/80">
          <div className="flex items-center gap-1.5">
            <CheckCircle2 className="w-4 h-4 text-primary-foreground" />
            <span>Fast Emergency Response</span>
          </div>
          <div className="flex items-center gap-1.5">
            <CheckCircle2 className="w-4 h-4 text-primary-foreground" />
            <span>{"Fully Insured & Certified"}</span>
          </div>
          <div className="flex items-center gap-1.5">
            <CheckCircle2 className="w-4 h-4 text-primary-foreground" />
            <span>5-Star Rated Service</span>
          </div>
        </motion.div>
      </div>
    </section>;
}